import Joi from 'joi';
import { objectId } from '@/shared/validations/custom.validation';

export const propertySizeValidation = {
  get: {
    params: Joi.object({
      id: Joi.string().custom(objectId).optional(),
    }).unknown(true),
    query: Joi.object().unknown(true),
  },

  create: Joi.object({
    name: Joi.string().trim().lowercase().required(),
    sqFeetUnit: Joi.number().required(),
    createdBy: Joi.string().custom(objectId).optional(),
    updatedBy: Joi.string().custom(objectId).optional(),
  }).unknown(true),

  update: {
    params: Joi.object({
      id: Joi.string().custom(objectId).required(),
    }).unknown(true),
    body: Joi.object({
      name: Joi.string().trim().lowercase().optional(),
      sqFeetUnit: Joi.number().optional(),
      updatedBy: Joi.string().custom(objectId).optional(),
    }).unknown(true),
  },

  delete: Joi.object({
    id: Joi.string().custom(objectId).required(),
  }).unknown(true),
};
